import { server } from "@/utils/client";
import { getToken } from "@/utils/Cookies";
import { create } from "zustand";

export interface SignType {
    /**
     * 活动也详情选择0跟随皮肤1样式1 2样式2
     */
    act_page: number;
    /**
     * 宣传预览图片链接
     */
    act_promotion_url: string;
    /**
     * 时间类型1永久2自定义
     */
    act_time_type: number;
    /**
     * 背景图片链接
     */
    Background: string;
    /**
     * //背景类型 1 默认 2自定义
     */
    background_type: number;
    /**
     * 活动展示结束时间
     */
    display_end_time: number;
    /**
     * 活动展示开始时间
     */
    display_start_time: number;
    /**
     * 活动结束时间
     */
    end_at: number;
    /**
     * 活动ID
     */
    id: number;
    /**
     * 内容展示
     */
    list: List[];
    /**
     * 名称
     */
    name: string;
    /**
     * 规则说明
     */
    remark: string;
    /**
     * 活动开始时间
     */
    start_at: number;
    /**
     * 活动类型
     */
    type: number;

    cur_num: number;

    is_op: boolean;
}

export interface List {
    /**
     * 奖励货类型
     */
    coin_type: number;
    /**
     * 额外奖励有效投注条件
     */
    extra_bet: number;
    /**
     * 额外奖励
     */
    extra_num: number;
    /**
     * 额外奖励充值条件
     */
    extra_pay_amount: number;
    /**
     * 第几天
     */
    id: number;
    /**
     * 图片
     */
    img: string;
    /**
     * 是否完成
     */
    is_suss: boolean;
    /**
     * 是否解锁额外奖励
     */
    is_unlock_extra_reward: boolean;
    /**
     * 奖励数量
     */
    num: number;
}
interface State {
    signData: Partial<SignType>;
    activity_id: string | number;
}

interface Action {
    getSignData: (data: { activity_id: number }) => void;
}

const initState: State = {
    signData: {},
    activity_id: 0,
};
const getSignDetailsApi = (data: { activity_id: number }) => {
    return server.post<SignType | []>({
        url: "/v1/api/user/activity/signInInfo",
        data,
    });
};
export const useSignStore = create<State & Action>()((set, get) => {
    return {
        ...initState,
        getSignData: async (data) => {
            if (getToken()) {
                getSignDetailsApi(data).then((res) => {
                    const resultData: any = Array.isArray(res.data) ? {} : res.data;
                    if (resultData?.list) {
                        resultData?.list.sort((a: any, b: any) => {
                            return a.id - b.id;
                        });
                    }
                    set((value) => ({
                        ...value,
                        activity_id: data.activity_id,
                        signData: resultData,
                    }));
                });
            }
        },
    };
});
